import { doc, getDoc } from "firebase/firestore";
import React, { useContext, useEffect, useState } from "react";
import config from "../../config";
import { EnvContext } from "../../context/EnvContext";
import FAQ from "../../elements/FAQ";
import FeaturedCarousel_DesktopV2 from "../../elements/FeaturedCarousel_DesktopV2";
import FeaturedCarousel_MobileV2 from "../../elements/FeaturedCarousel_MobileV2";
import Footer from "../../elements/Footer";
import Header from "../../elements/Header";
import { useFirestore } from "../../firebase/FirestoreContext";
import useWindowSize from "../../utils/useWindowSize";

const breakpoints = [755]
const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`)

const HelpCenter = () => {
  const db = useFirestore();

  // get AboutUs from Firebase
  const [aboutUs, setAboutUs] = useState(null);
  const environment = useContext(EnvContext);
  const { width } = useWindowSize();
  const isMobile = width <= 768;

  const collectionPath = environment === "staging" ? config.environment.staging.collectionPath : config.environment.production.collectionPath;

  useEffect(() => {
    const fetchAboutUs = async () => {
      try {
        const userDocRef = doc(db, `${collectionPath}Pages/HelpCenter`);
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          // Correctly accessing the field from the document data.
          setAboutUs(userDocSnap.data().page_content);
        } else {
          console.error("No About Us page found.");
        }
      } catch (error) {
        console.error("Error fetching About Us:", error);
      }
    };

    fetchAboutUs();
  }, [db, collectionPath]);

  return (
    <>
      <Header search={false} />

      <div style={{ display: "flex", flexDirection: "column", maxWidth: "1140px", margin: "0 auto" }}>
        <div style={{ display: "flex", flexDirection: "column", flex: 1, borderTop: "1px solid black", marginTop: 35 }}>
          {isMobile && <FeaturedCarousel_MobileV2 featuredCollection={"helpcenter"} containerStyles={{ margin: "20px 0" }} />}
          {!isMobile && <FeaturedCarousel_DesktopV2 featuredCollection={"helpcenter"} containerStyles={{ margin: "20px 0" }} />}
          <div style={{ padding: "15px" }}>
            <div
              css={{
                padding: "10px 0 5px 0",
                fontWeight: 500,
                fontSize: "0.9rem",
                [mq[0]]: {
                  fontSize: "1.2rem"
                }
              }}
              className="ql-editor"
              dangerouslySetInnerHTML={{ __html: aboutUs }}
            />
          </div>
        </div>
        <div style={{ height: 100 }} />
        <FAQ />
      </div>
      <Footer />
    </>
  );
};

const styles = {
  title: {
    fontSize: "1.2rem",
    fontWeight: "600",
    marginBottom: 20,
  },
  content: {
    padding: "0px 0",
    fontWeight: "500",
    fontSize: ".9rem",
  },

  image: {
    container: {
      display: "flex",
      justifyContent: "center",
      borderRadius: 8,
      overflow: "hidden",
    },
    image: {
      width: "100%",
      height: "auto",
    },
  },
};

export default HelpCenter;
